export default {
  item: (height: number) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    flexShrink: 0,
    minHeight: height > 0 ? `${height}px` : '100vh',
    height: height > 0 ? `${height}px` : '100vh'
  }),
  slide: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: '100%',
    width: '100%'
  },
  mainImageDescription: {
    width: '100%',
    padding: '40px 64px 0 40px',
    flexShrink: 0
  },
  mainImageProduct: {
    width: '100%',
    flexShrink: 0
  },
  contentDescription: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
    minHeight: 0,
    padding: '0 64px 40px 40px'
  },
  contentProduct: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    minHeight: 0,
    padding: '16px 64px 0 40px'
  }
};